import axiosConfig from './axiosConfig';

const userAPI = {};

userAPI.delete = (url) => axiosConfig.delete(url);
userAPI.getCurrentUser = () => axiosConfig.get('/api/users/current/');
// Staff only - how many team requests are waiting for review.
userAPI.getPendingTeamRequestCount = () => axiosConfig.get('/api/team/request/pending-count/');

export default userAPI;